// extracted by mini-css-extract-plugin
export default {"customCaption":"Carousel_customCaption__A049z","title":"Carousel_title__Wuoe2","body":"Carousel_body__VYEj+","img":"Carousel_img__243C1"};